import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const recruiterHeader = {
    mobile: {
        header: {
            background: Color.DeepBlack,
            marginTop: "0%",
            marginLeft: "0%",
            width: "100%",
            height: "18.84vw",
            opacity: "1",
            position: "relative"
        },
        row: {
            display: "flex",
            flexDirection: "row" as "row",
            position: "relative",
            height: "-webkit-fill-available"
        },
        backButton: {
            wrapper: {
                display: "none",
                alignSelf: "center",
                marginLeft: "1.98vw"
            },
            button: {
                width: "2.08vw",
                height: "2.08vw",
                backgroundColor: Color.White,
                boxShadow: "0px 0px 0px 0.42vw rgb(255 255 255 / 0.35)",
                borderRadius: "50%"
            },
            icon: {
                fill: Color.MiddleBlack,
                width: "50%",
                marginTop: "0.15vw"
            },
            text: {
                display: "inline",
                marginLeft: "1.04vw",
                fontSize: "0.93vw",                
                fontWeight: "bold",
                color: Color.White
            }
        },
        title: {
            margin: "4.83vw 0 0 4.83vw",
            cursor: "pointer",
            width: "39.37vw",
            height: "9.18vw"
        },
        label: {
            textDecoration: "none",
            fontSize: "4.34vw",
            fontWeight: "bold" as "bold",
            letterSpacing: "0px",
            color: Color.LightAsh,
            opacity: "1",
            cursor: "pointer",
            hover: {
                borderBottom: "2px solid " + Color.DarkAsh
            }
        },
        dropdownLabel: {
            position: "relative" as "relative",
            textDecoration: "none",
            fontSize: "4.4vw",
            fontWeight: "medium",
            letterSpacing: "0px",
            color: Color.MiddleBlack,
            cursor: "pointer",
            opacity: "1"
        },
        dropdownItem: {
            color: Color.MiddleBlack,
            fontWeight: "500",
            hover: {
                backgroundColor: Color.Blue,
                padding: "1.38vw",
                borderRadius: "1.94vw",
                color: Color.White
            },
            leave: {
                backgroundColor: Color.White,
                padding: "1.38vw"
            }
        },
        desktopMenu: {
            more: {
                hover: {
                    width: "11.2vw",
                    left: "-2.8vw",
                    zIndex: "20"
                }
            }
        },
        loginWrapper: {
            display: "none",
            alignSelf: "center"
        },
        recruitersButton: {
            height: "3.64vw",
            width: "14.58vw",
            color: Color.White,
            fontWeight: "bold" as "bold",
            backgroundColor: Color.Blue, 
            border: "none",           
            WebkitTapHighlightColor: "transparent",
            position: "relative" as "relative",
            marginRight: "2.60vw",            
            transform: "none",            
            fontSize: "1.04vw",
            borderRadius: "0.52vw",            
            cursor: "pointer"
        },
        jobSeekersButton: {
            height: "3.64vw",
            width: "14.58vw",
            color: Color.White,
            fontWeight: "bold" as "bold",
            backgroundColor: Color.DeepBlack,
            border: "0.16vw solid " + Color.Green,            
            WebkitTapHighlightColor: "transparent",
            position: "relative" as "relative",
            marginRight: "0.83vw",            
            transform: "none",            
            fontSize: "1.04vw",
            borderRadius: "0.52vw",            
            cursor: "pointer"
        },
        mobileMenuButton: {
            backgroundColor: "transparent",
            border: "none",
            margin: "0 4.83vw 0 auto"
        },
        profileWrapper: {
            display: "none"
        }
    },
    desktop: {
        header: {            
            height: "7.81vw"
        },
        backButton: {            
            wrapper: {
                alignSelf: "none",
                display: "flex",
                marginTop: "2.91vw"                   
            },
            text: {
                marginTop: "0.5vw"
            }            
        },
        title: {
            margin: "2.08vw 0 0 2.70vw",
            width: "15.52vw",
            height: "3.65vw"  
        },
        label: {
            fontSize: "0.937vw"
        },
        dropdownLabel: {
            fontSize: "0.937vw"
        },
        dropdownItem: {
            fontSize: "0.83vw",         
            hover: {
                borderRadius: "0.36vw",
                padding: "0.31vw 0.52vw"
            },
            leave: {
                padding: "0.31vw 0.52vw"
            }
        },     
        loginWrapper: {
            display: "inline"
        },   
        mobileMenuButton: {
            display: "none"
        },
        profileWrapper: {
            display: "flex",
            marginTop: "3vh",
            marginRight: "1.5vw"
        }
    }
}